import React from "react";
import CharginIcon from "icons/charging_point.svg";
import LocationIcon from "icons/location_on.svg";
import BakeryIcon from "icons/bakery_dining.svg";
import WifiIcon from "icons/wifi.svg";
import AcIcon from "icons/ac.svg";
import GpsIcon from "icons/gpsLarge.svg";
import FanIcon from "icons/fan.svg";
import WaterBottleIcon from "icons/water_bottle.svg";
import PersonalTVIcon from "icons/personal_tv.svg";
import SnacksIcon from "icons/snacks.svg";
import NewsPaperIcon from "icons/newspaper.svg";
import EmergencyExitIcon from "icons/emergency_exit.svg";
import BlanketIcon from "icons/blanket.svg";
import FireExtinguisherIcon from "icons/fire_extinguisher.svg";
import HammerIcon from "icons/hammer.svg";
import ReadingLightIcon from "icons/reading_light.svg";
import VomitingBagIcon from "icons/vomiting_bag.svg";
import CCTVIcon from "icons/cctv.svg";
import WaterBottleHolderIcon from "icons/water_bottle_holder";
import FirstAidBoxIcon from "icons/first_aid_box.svg";
import MealIcon from "icons/meal.svg";
import ExtraLegSpaceIcon from "icons/extra_leg_space.svg";
import HeaterIcon from "icons/heater.svg";
import HandSanitizerIcon from "icons/hand_sanitizer.svg";
import MaskIcon from "icons/mask.svg";
import BusSanitizationIcon from "icons/bus_sanitization.svg";
import SocialDistanceIcon from "icons/social_distancing.svg";
import PillowIcon from "icons/pillow.svg";
import ToiletIcon from "icons/toilet.svg";
import ThermalScreeningIcon from "icons/thermal_screening.svg";
import FacialTissuesIcon from "icons/facial_tissues.svg";
import FilterationIcon from "icons/filteration.svg";
import CoffeeIcon from "icons/coffee.svg";
import BreakfastIcon from "icons/breakfast.svg";
import LunchIcon from "icons/lunch.svg";
import DinnerIcon from "icons/dinner.svg";
import RestaurantIcon from "icons/restaurant.svg";
import RoomServiceIcon from "icons/room_service.svg";

export const getAmenities = (amen: string, dark = true) => {
  const fill = dark ? "#1a1a1a" : "#ffffff";
  const stroke = dark ? "#1a1a1a" : "#ffffff";

  switch (amen.toLowerCase().split(" ").join("_")) {
    case "charging_point":
      return <CharginIcon fill={fill} />;
    case "location_on":
      return <LocationIcon fill={fill} />;
    case "brunch":
    case "bakery_dining":
      return <BakeryIcon fill={fill} />;
    case "wifi":
      return <WifiIcon fill={fill} />;
    case "ac":
      return <AcIcon fill={fill} />;
    case "gps":
      return <GpsIcon />;
    case "fan":
      return <FanIcon fill={fill} />;
    case "water_bottle":
      return <WaterBottleIcon fill={fill} />;
    case "desktop_windows":
    case "central_tv":
    case "personal_tv":
      return <PersonalTVIcon fill={fill} />;
    case "snacks":
      return <SnacksIcon fill={fill} />;
    case "newspaper":
    case "novel":
      return <NewsPaperIcon fill={fill} />;
    case "emergency_exit":
      return <EmergencyExitIcon stroke={stroke} />;
    case "blanket":
      return <BlanketIcon fill={fill} />;
    case "fire_extinguisher":
      return <FireExtinguisherIcon fill={fill} />;
    case "hammer":
      return <HammerIcon fill={fill} />;
    case "reading_light":
      return <ReadingLightIcon fill={fill} />;
    case "vomiting_bag":
      return <VomitingBagIcon />;
    case "cctv":
      return <CCTVIcon fill={fill} />;
    case "water_bottle_holder":
      return <WaterBottleHolderIcon dark />;
    case "first_aid_box":
      return <FirstAidBoxIcon fill={fill} />;
    case "meal":
      return <MealIcon fill={fill} />;
    case "extra_leg_space":
      return <ExtraLegSpaceIcon fill={fill} />;
    case "bipolar_ionisation":
    case "bus_sanitization":
    case "bus_crew_covid_tested":
      return <BusSanitizationIcon fill={fill} />;

    case "heater":
      return <HeaterIcon stroke={stroke} />;
    case "hand_sanitizer":
      return <HandSanitizerIcon fill={fill} />;
    case "passenger_face_mask":
    case "staffs_with_facemask":
      return <MaskIcon fill={fill} />;

    case "social_distancing":
      return <SocialDistanceIcon fill={fill} />;
    case "pillow":
      return <PillowIcon fill={fill} />;
    case "toilet":
      return <ToiletIcon fill={fill} stroke={stroke} />;

    case "facial_tissues":
      return <FacialTissuesIcon fill={fill} />;
    case "thermal_screening":
      return <ThermalScreeningIcon fill={fill} />;
    case "filteration":
      return <FilterationIcon fill={fill} />;
    case "coffee":
      return <CoffeeIcon fill={fill} />;
    case "breakfast":
      return <BreakfastIcon fill={fill} />;

    case "lunch":
      return <LunchIcon fill={fill} />;
    case "dinner":
      return <DinnerIcon stroke={stroke} />;
    case "restaurant":
      return <RestaurantIcon fill={fill} />;
    case "room_service":
      return <RoomServiceIcon stroke={stroke} />;
    default:
      return null;
  }
};
